import React, { memo, useEffect } from "react"
import { useLocation } from "@reach/router"
import { navigate } from "gatsby"
import Filters from './filters'

const SidebarFilters = ({
  categories,
  filterOptions,
  categoryFilter,
  setCategoryFilter,
  filter,
  setFilter,
  showSidebar,
  setShowSidebar,
  setFilterList
}) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const categoryOptions = categories.map(cat => ({ name: cat.node.name, slug: cat.node.slug, id: cat.node.id }));


  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const filtered = [];
    const cat = params.get("cat");
    const filter = params.get("filter");

    setCategoryFilter(cat);
    setFilter(filter);

    const catName = categories.find(item => item.node.slug === cat);
    const filterName = filterOptions.find(item => item.slug === filter);

    if (catName) filtered.push({ type: 'cat', value: catName.node.name });
    if (filterName) filtered.push({ type: 'filter', value: filterName.name });

    setFilterList(filtered);
  }, [location.href])  //eslint-disable-line react-hooks/exhaustive-deps

  const handleFilters = (type, filter, selectedFilter, stateFunc) => {
    if (params.has(type)) {
      params.delete(type);
    }
    if (filter.slug !== selectedFilter) {
      stateFunc(filter.slug);
      params.append(type, filter.slug);
      params.sort();
    } else {
      stateFunc(null);
    }
    navigate(`${location.pathname}?${params.toString()}`)
  }

  return (
    <>
      {showSidebar && <div className='absolute z-50 backdrop-filter transition duration-1000 backdrop-blur w-screen h-screen top-0 left-0' />}
      <div className={`flex-col flex w-1/5 lg:h-full pr-1 absolute top-0 z-50 lg:left-0 h-screen lg:relative mr-6
      ${showSidebar ? 'left-0 transition-all w-screen duration-500 ' : '-left-72'}
    `}
        onClick={() => { setShowSidebar(false) }}>
        <div className={`bg-creamLight z-50 relative lg:bg-transparent ${showSidebar ? 'rounded-r-2xl p-7 h-full w-max px-3 pt-14 lg:pt-0 lg:px-0' : ''}`}>
          {/* Category */}
          < Filters
            title="Categories"
            data={categoryOptions}
            filterSelected={categoryFilter}
            handleClick={(value) => { handleFilters('cat', value, categoryFilter, setCategoryFilter) }}
          />

          {/* Filter */}
          <Filters
            title="Filter by"
            data={filterOptions}
            filterSelected={filter}
            handleClick={(value) => handleFilters('filter', value, filter, setFilter)}
          />
        </div >
      </div>
    </>
  )
}

export default memo(SidebarFilters)
